export enum HttpMethod {
	GET='GET',
	PUT='PUT',
	POST='POST',
	DELETE='DELETE',
	PATCH='PATCH',
}